import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RegisterForOwnerComponent } from './register-for-owner.component';

const routes: Routes = [{ path: '', component: RegisterForOwnerComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegisterForOwnerRoutingModule { }
